import React, { Fragment } from 'react';
import { SectionHeader } from '../ui/Shared';
export function HowItWorksSection() {
  const steps = [{
    title: 'Aplica la técnica del Vaso de Agua Tibia',
    desc: 'Detén el dolor inmediato esta misma noche activando el mecanismo de defensa natural de tu cuerpo.'
  }, {
    title: 'Inicia el Ciclo de Sábila de 20 días',
    desc: 'Sella y regenera la mucosa de tu esófago creando un escudo protector biológico contra el ácido.'
  }, {
    title: 'Elimina gatillos y ajusta tu posición',
    desc: 'Saca los 5 alimentos gatillo silenciosos y ajusta tu posición al dormir para que el reflujo no regrese jamás.'
  }];
  return <section id="como-funciona" className="py-24" data-id="element-241">
      <div className="max-w-[780px] mx-auto px-6" data-id="element-242">
        <SectionHeader tag="El proceso" title={<>
              3 pasos simples para
              <br data-id="element-244" />
              apagar el fuego
            </>} data-id="element-243" />

        <div className="stagger-children mt-12" data-id="element-245">
          {steps.map((step, idx) => <Fragment key={idx} data-id="element-246">
              <div className="flex flex-col md:flex-row gap-4 md:gap-7 mb-8 md:mb-12 items-start" data-id="element-247">
                <div className="w-11 h-11 md:w-14 md:h-14 bg-gradient-gold rounded-full flex items-center justify-center font-playfair text-xl md:text-2xl font-black text-primary shrink-0" data-id="element-248">
                  {idx + 1}
                </div>
                <div className="mt-1 md:mt-0" data-id="element-249">
                  <h3 className="text-xl font-bold mb-2 text-text-light" data-id="element-250">
                    {step.title}
                  </h3>
                  <p className="text-base text-text-muted leading-relaxed" data-id="element-251">
                    {step.desc}
                  </p>
                </div>
              </div>
              {idx < steps.length - 1 && <div className="w-0.5 h-8 bg-gradient-to-b from-accent to-transparent ml-[21px] md:ml-[27px] -mt-4 mb-4 md:mb-0 hidden md:block" data-id="element-252" />}
            </Fragment>)}
        </div>
      </div>
    </section>;
}